import { useState } from "react";
import "./SolveMCQ.css"
import NavBar from "../../../Universal Components/NavBar/NavBar";
import MCQProblem from "./MCQProblem";
import { useLocation } from "react-router-dom"; // This is used to foreward problem ID from the table to the solve page & run button (https://www.reddit.com/r/reactjs/comments/r1onuc/passing_objects_through_usenavigate/)
import { addProblemToSolved } from "../../../Firebase/FireStore";
import { getProblemById } from "../../../Data/ProblemsMethod";

export default function SolveMCQ(){
    const { state } = useLocation();
    const currProblem = getProblemById(state.problem_id);

    const [index_of_selected_mcq_problem, set_index_of_selected_mcq_problem] = useState(0); // Which problem, if more than 1, is selected
    const problemDescription = currProblem?.problem_description[index_of_selected_mcq_problem];
    const mcqOptions = currProblem?.mcq_options[index_of_selected_mcq_problem]; // The list of options presented to the user
    const [is_problem_correct, set_is_problem_correct] = useState(currProblem?.correct_mcq_options.map(() => "empty")) // The state of the user selection (empty, selected, correct, incorrect)

    // 2d array to store the users selection options for every question in the problem
    const numProblems = currProblem?.problem_description.length;
    const numSolutions = currProblem?.correct_mcq_options.map((array_of_solutions) => {
        return array_of_solutions.length;
    })


    const [option_selected, set_option_selected] = useState("Problem");  



    const [user_solutions, set_user_solutions] = useState(() => {
        return Array.from({ length: numProblems }, () => []);
    });
    function updateSolutionAt(i, newRowArray) {
        set_user_solutions(prev => {
          const next = [...prev];    // shallow‐copy outer
          next[i] = newRowArray;     // replace row i
          return next;
        });
    }
    function setCorrectAt(i, isCorrectString) {
        set_is_problem_correct(prev => {
          const newList = [...prev];    
          newList[i] = isCorrectString;     
          return newList;
        });
    }

    
    const problem_circles = currProblem?.problem_description.map((_, idx)=> {
        const responseState = is_problem_correct[idx]
        return <span className="circle"
                    style={{
                        backgroundColor: responseState==="empty" ? 'transparent' :
                            responseState==="selected" ? "gray" :
                            responseState==="correct" ? "green" : "red",
                        
                        border: responseState==="empty" ? '1.5px solid #787878' :
                            responseState==="correct" ? "green" : "red",
                        }}
                        
                />
        });


    if(mcqOptions === null || problemDescription === null)
        throw new Error("Bad format for mcq options in solveMCQ");

    return(
        <>
            <NavBar/>

            <MCQProblem
                problemDescription={problemDescription} 
                numSolutions={numSolutions} 
                mcqOptions={mcqOptions}
                indexOfSelectedMCQProblem={index_of_selected_mcq_problem}
                setIndexOfSelectedMCQProblem={set_index_of_selected_mcq_problem}
                numProblems={numProblems}
                userSolutions = {user_solutions}
                updateSolutionAt={updateSolutionAt}
                option_selected={option_selected}
                set_option_selected={set_option_selected}
                setCorrectAt={setCorrectAt}
                isProblemCorrect={is_problem_correct}
            />

            {
                option_selected == "Problem" && 
                <div className="submit-and-circles-wrapper">


                    <div className="has-made-selection-container">
                        {problem_circles}
                    </div>


                    <div className="submit-solution"
                        onClick={() => {
                            let allCorrect = true;


                            for(let i = 0; i < numProblems; i++){
                                let thisProblemCorrect = true
                                if(user_solutions[i].length === 0){ //User has not answered this question
                                    set_index_of_selected_mcq_problem(i)
                                    return;
                                }
                                if(user_solutions[i].length !== currProblem.correct_mcq_options[i].length){
                                    allCorrect = false;
                                    thisProblemCorrect = false
                                } else{
                                    const sortedUser = [...user_solutions[i]].sort(); // clone & sort
                                    const sortedSolution = [...currProblem.correct_mcq_options[i]].sort();
                                    const tempBoolean = sortedUser.every((val, i) => val === sortedSolution[i]);
                                    allCorrect &= tempBoolean
                                    thisProblemCorrect &= tempBoolean
                                }
                                setCorrectAt(i, thisProblemCorrect ? "correct" : "incorrect")
                            }    
                            if(allCorrect)
                                addProblemToSolved(state.problem_id)

                            
                        }}    
                    >
                        Submit
                    </div>
                

                </div>
            }
        </>
    );
}